<div class="drill-header">
  <span class="drill-title">{{ name }}</span>
  <button type="button" class="drill-close" (click)="close()" aria-label="Close">×</button>
</div>
<div class="drill-body">
  <bst-self-dashboard-grid [scope]="scope" [anchor]="anchor" [actorCanSeeBillRate]="actorCanSeeBillRate"></bst-self-dashboard-grid>
</div>
